<template>
  <img
    id="logo"
    :src="require('@/assets/images/logo/Logo Pernambucanas.svg')"
    alt="Logo
      Pernambucanas"
    :class="stylizationLogo"
  />
</template>
<script>
export default {
  name: "Logo",
  props: {
    stylizationLogo: String,
  },
};
</script>
